import { Coingecko2 } from '@ui/uikit/components/icons/poly';
import { Link } from '@utilities/Link';

import styles from './CoingeckoLink.module.scss';

type CoingeckoLinkProps = {
  href?: string;
  isLoading: boolean;
  symbol?: string;
};

export const CoingeckoLink = ({ href, isLoading, symbol }: CoingeckoLinkProps) => {
  if (!href) {
    return null;
  }

  return isLoading && !symbol ? (
    <div className="msq-skeleton-text w-16 h-6" />
  ) : (
    <Link href={href} target="_blank" className={styles.link}>
      <span className={styles.symbol}>{symbol} on</span>
      <Coingecko2 width={14} />
      <span className={styles.brand}>Coingecko</span>
    </Link>
  );
};
